export default __webpack_public_path__ + "static/media/AtzelsApproach.b3c4d7c7.jpg";